// Deliberately small, local-only typo map. No text leaves the browser.
const SAFE_REPLACEMENTS = Object.freeze({
  freind: 'friend', freinds: 'friends', recieve: 'receive', recieved: 'received',
  beleive: 'believe', becuase: 'because', teh: 'the', thier: 'their',
  gardning: 'gardening',
  dont: "don't", doesnt: "doesn't", didnt: "didn't", cant: "can't",
  wont: "won't", im: "I'm", ive: "I've", isnt: "isn't", wasnt: "wasn't",
});

export const isTextCorrectionEnabled = (settings) => settings?.client_text_correction_enabled === true;
export const isClientTextCorrectionEnabled = isTextCorrectionEnabled;
export const isCorrectionEngineReady = () => Object.keys(SAFE_REPLACEMENTS).length > 0;
export const getClientTextCorrectionDiagnostic = (settings) => ({
  client_text_correction_enabled: isClientTextCorrectionEnabled(settings),
  correction_engine_ready: isCorrectionEngineReady(),
});
export const shouldProtectToken = (token) => {
  const value = String(token || '');
  return !value || /\d|[_@/#]|[A-Z].*[A-Z]/.test(value);
};
export const getTextCorrectionSuggestion = (text) => {
  const original = String(text ?? '');
  if (!original.trim()) return null;
  let changed = false;
  const corrected = original.replace(/\b[A-Za-z']+\b/g, (token) => {
    if (shouldProtectToken(token)) return token;
    const replacement = SAFE_REPLACEMENTS[token.toLocaleLowerCase()];
    if (!replacement) return token;
    changed = true;
    return token[0] === token[0].toUpperCase() ? replacement[0].toUpperCase() + replacement.slice(1) : replacement;
  });
  return changed && corrected !== original ? { original, corrected } : null;
};
export const applyConservativeCorrection = (text) => getTextCorrectionSuggestion(text)?.corrected ?? text;
